export const SET_REVIEW_PARAMS = 'SET_REVIEW_PARAMS'
export const SET_EDUCATION_LAW = 'SET_EDUCATION_LAW'